"use client";

import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { WelcomeComponent } from "./WelcomeCreatorsStep";
import BrowseCreatorsStep from "./ShowCreatorsStep";
import ShowFiltersStep from "./ShowFiltersStep";
import ShowHeaderTabsStep from "./ShowHeaderTabsStep";

interface ControlDemoComponentsProps {
  intendedRoute?: string | null;
  onNavigate: (to: string) => void;
  onComplete?: () => void;
}

export function ControlDemoComponents({ intendedRoute, onNavigate, onComplete }: ControlDemoComponentsProps) {
  const [isVisible, setIsVisible] = useState(true);
  const [role, setRole] = useState<"brand" | "creator">("brand");
  const [step, setStep] = useState<0 | 1 | 2 | 3>(0);

  const redirectTo = intendedRoute && intendedRoute !== "/" ? intendedRoute : "/sign-in";

  const handleNext = () => {
    if (step === 0) {
      setStep(1);
      return;
    }
    if (step === 1) {
      setStep(2);
      return;
    }
    if (step === 2) {
      setStep(3);
      return;
    }
    // Finish tour: close overlay and allow browsing the page
    setIsVisible(false);
    onComplete?.();
  };

  const handlePrev = () => {
    if (step === 1) {
      setStep(0);
      return;
    }
    if (step === 2) {
      setStep(1);
      return;
    }
    if (step === 3) {
      setStep(2);
      return;
    }
  };

  const handleSkip = () => {
    setIsVisible(false);
    onComplete?.();
    onNavigate("/sign-in");
  };

  // Disable background scroll while overlay is visible
  useEffect(() => {
    const prev = document.body.style.overflow;
    if (isVisible) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isVisible]);

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 z-50">
          <div className="relative w-full h-full">
            {/* Backdrop only for welcome step */}
            {step === 0 && <div className="absolute inset-0 bg-black/50" />}
            <AnimatePresence mode="wait">
              {step === 0 ? (
                <WelcomeComponent
                  onNext={handleNext}
                  onSkip={handleSkip}
                  position="center"
                  spotlight={false}
                  showArrow={false}
                  currentStep={0}
                  totalSteps={4}
                />
              ) : step === 1 ? (
                <BrowseCreatorsStep
                  role={role}
                  onRoleChange={setRole}
                  selectedRole={role}
                  onNext={handleNext}
                  onSkip={handleSkip}
                  onPrev={handlePrev}
                  currentStep={1}
                  totalSteps={4}
                  spotlight
                  showArrow={false}
                />
              ) : step === 2 ? (
                <ShowFiltersStep
                  onNext={handleNext}
                  onSkip={handleSkip}
                  onPrev={handlePrev}
                  currentStep={2}
                  totalSteps={4}
                  spotlight
                  showArrow={false}
                />
              ) : (
                <ShowHeaderTabsStep
                  onNext={handleNext}
                  onSkip={handleSkip}
                  onPrev={handlePrev}
                  currentStep={3}
                  totalSteps={4}
                  spotlight
                  showArrow={false}
                />
              )}
            </AnimatePresence>
          </div>
        </div>
      )}
    </>
  );
}

export default ControlDemoComponents;


